import { formatCurrency, formatNumber } from "../../intl_helpers";

export const formatTokenPrice = (price: number) => {
  return formatCurrency(price, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  });
};

const formatTokenCount = (count: number) => {
  return formatNumber(count, {
    maximumSignificantDigits: 2,
    roundingMode: "trunc",
  });
};

export function humanizeTokenCount(count: number): string {
  if (Number.isNaN(count)) {
    return "—";
  }

  if (!Number.isFinite(count)) {
    return "∞";
  }

  const powers = [
    [9, "B"],
    [6, "M"],
    [3, "K"],
  ];

  for (const [power, suffix] of powers) {
    const n = 10 ** Number(power);
    if (count >= n) {
      return formatTokenCount(count / n) + suffix;
    }
  }

  return formatTokenCount(count);
}
